"use strict";

exports.__esModule = true;

var state_1 = require("../../store/state");

var dispatch_1 = require("../../store/dispatch");

var actions_1 = require("../../store/actions");

function start(label) {
  dispatch_1["default"](actions_1.timeStart(label));
}

exports.start = start;

function stop(label) {
  var timing = state_1.state.timings[label];

  if (timing && !timing.end) {
    dispatch_1["default"](actions_1.timeEnd(label));
    var time = state_1.state.timings[label].time;
    return {
      method: 'log',
      data: [label + ": " + time + "ms"]
    };
  }

  return {
    method: 'warn',
    data: ["Timer '" + label + "' does not exist"]
  };
}

exports.stop = stop;